function safeRun(fn, failValue) {
  try {
    return fn();
  } catch (e) {
    // noop
    console.warn("LocalStorage Error: ", e.message);
    return failValue;
  }
}

const LS = {
  _jsonKey(key) {
    return key + ":type:jsonstring";
  },
  getItem(key) {
    return safeRun(() => {
      let value = localStorage.getItem(key);
      if (value != null) return value;
      value = localStorage.getItem(this._jsonKey(key));
      if (value) value = JSON.parse(value);
      return value;
    }, null);
  },
  setItem(key, value) {
    if (value == null) return this.removeItem(key);

    if (typeof value == "object") {
      value = JSON.stringify(value);
      key = this._jsonKey(key);
    }
    return safeRun(() => {
      localStorage.setItem(key, value);
      return value;
    }, null);
  },
  removeItem(key) {
    safeRun(() => {
      localStorage.removeItem(key);
      localStorage.removeItem(this._jsonKey(key));
    });
    return null;
  },
};
window.LS = LS;

const UNI_COLS = ["the-university-collection-pre-designed-rings"];
const UNI_FILTER_PARAM_KEY = "filter.p.m.srch.university"; // also used in liquid files. Search in whole theme if modified
const UNI_FILTER_URL_KEY = "saved_uni_collection_url";

const state = {
  currentUniFilter: null,
  savedUni: LS.getItem(UNI_FILTER_PARAM_KEY) || null,
};

function afterUrlChange() {
  const template = document.body.getAttribute("data-template-name");
  const pageHandle = document.body.getAttribute("data-handle");

  const url = new URL(window.location.href);
  const uniFromParam = url.searchParams.get(UNI_FILTER_PARAM_KEY) || null;
  const isUniUrl = uniFromParam && uniFromParam.startsWith("/collections/");
  console.log({ isUniUrl });
  state.currentUniFilter = uniFromParam;

  if (state.savedUni != state.currentUniFilter) {
    if (state.currentUniFilter == null) {
      // Is collection page &&
      // collection matches the uni collection
      if (
        template == "collection" &&
        UNI_COLS.some((handle) => handle == pageHandle)
      ) {
        LS.setItem(UNI_FILTER_PARAM_KEY, state.currentUniFilter);
        state.savedUni = state.currentUniFilter;
        LS.removeItem(UNI_FILTER_URL_KEY);
      }
    } else {
      LS.setItem(UNI_FILTER_PARAM_KEY, state.currentUniFilter);
      state.savedUni = state.currentUniFilter;
      LS.removeItem(UNI_FILTER_URL_KEY);
    }
  }

  if (state.savedUni && !isUniUrl) {
    updateCollectionLinksWithUni(state.savedUni);
  }

  if (!state.savedUni) {
    document
      .querySelectorAll(".universities-combobox data-combobox-input")
      .forEach((input) => {
        input.value = "";
        input.dispatchEvent(new Event("keydown"));
      });
  }

  console.log(state);
}

// Run before page load
afterUrlChange();

function updateCollectionLinksWithUni(uni) {
  if (!uni) return;

  const uniCollectionLinks = document.querySelectorAll(
    UNI_COLS.map(
      (handle) =>
        `a[href*="/collections/${handle}"]:not([data-uni-filter-fixed], x-combobox a, .filter-bar a, .filter-drawer a)`
    ).join(", ")
  );

  uniCollectionLinks.forEach((a) => {
    let href = a.getAttribute("href");
    if (!href || !href.startsWith("/collections/")) return;

    if (href.includes("?")) {
      let [pathname, search] = href.split("?");
      if (search) {
        const sp = new URLSearchParams(search);
        sp.set(UNI_FILTER_PARAM_KEY, uni);
        href = `${pathname}?${sp.toString()}`;
      }
    } else {
      href = `${href}?${UNI_FILTER_PARAM_KEY}=${decodeURIComponent(uni)}`;
    }
    // console.log({ href: a.getAttribute('href'), next: href})
    a.setAttribute("href", href);
    a.setAttribute("data-uni-filter-fixed", "true");

    // ['', 'collections', 'university-rings']
    // const parts = href.split('/')
    // if (parts.length >=2 && parts[0] == '' && parts[1] == 'collections') {
    //   parts[2] = `${parts[2]}?${UNI_FILTER_PARAM_KEY}=${uni}`
    // }
  });
}

window.addEventListener("popstate", () => {
  return afterUrlChange();
});

document.addEventListener("collection:updated", ({ detail }) => {
  const doc = detail.doc;
  if (!doc) return;

  afterUrlChange();

  // Update filter bar attrs
  copyAttrsFromNewDoc(
    ".filter-bar .filter-bar__filters-inner .filter-group",
    doc
  );

  // Update filter drawer attrs
  copyAttrsFromNewDoc(
    ".filter-drawer[data-filter-drawer] .filter-drawer__group",
    doc
  );

  document.querySelectorAll(".universities-combobox").forEach((el) => {
    try {
      el._input.value = state.savedUni || "";
    } catch (e) {
      // noop
    }
  });
});

function copyAttrsFromNewDoc(selector, doc) {
  const currentElements = document.querySelectorAll(selector);
  const nextElements = doc.querySelectorAll(selector);

  currentElements.forEach((currentEl, i) => {
    const nextEl = nextElements[i];
    const nextElDatasetKeys = Object.keys(nextEl.dataset);
    nextElDatasetKeys.forEach((key) => {
      currentEl.dataset[key] = nextEl.dataset[key];
    });
  });
}

// remove all filters if uni is removed
document.addEventListener(
  "click",
  (e) => {
    const t = e.target;
    if (t instanceof HTMLElement) {
      const universityRemoveBadge =
        t.hasAttribute("data-remove-filter") &&
        t.getAttribute("data-name") === UNI_FILTER_PARAM_KEY;
      if (universityRemoveBadge) {
        e.preventDefault();
        e.stopPropagation();
        const clearAllBtn = t.parentElement.querySelector(
          "[data-clear-all-filters]"
        );
        if (clearAllBtn) clearAllBtn.click();
      }
    }
  },
  { capture: true }
);

function randstr(prefix) {
  return Math.random()
    .toString(36)
    .replace("0.", prefix || "");
}

class XCombobox extends HTMLElement {
  constructor() {
    super();
    // random string id
    this._onInputKeyup = this._onInputKeyup.bind(this);
    this._onInputKeydown = this._onInputKeydown.bind(this);
    this._onInputClick = this._onInputClick.bind(this);
    this._onListKeyDown = this._onListKeyDown.bind(this);
    this._onOptionClick = this._onOptionClick.bind(this);

    if (!this.id) this.id = randstr("xcombobox_");

    this._input = this.querySelector("input[data-combobox-input]");
    this._listElement = this.querySelector("[data-combobox-list]");
    this._options = Array.from(
      this.querySelectorAll("[data-combobox-listitem]")
    );

    this._listElement.setAttribute("role", "listbox");
    this._options.forEach((item) => {
      const value = item.getAttribute("data-combobox-listitem");
      item._x_combobox_value = value;

      let synonyms = item.getAttribute("data-synonyms");
      if (synonyms)
        synonyms = synonyms.split(",").reduce((acc, x) => {
          x = x.trim();
          if (x) acc.push(x.toLowerCase());
          return acc;
        }, []);

      const lowerCasedValue = value
        .trim()
        .toLowerCase()

      const sanitized = lowerCasedValue
        .replace(" at ", "")
        .replace(/\s+/g, " ")
        .replace(/&/g, " ");
      item._x_combobox_value_sanitized = sanitized;
      item._x_combobox_value_lowercased = lowerCasedValue;

      const words = sanitized.split(" ");

      let alt = "";
      if (sanitized.startsWith("university of")) {
        alt = sanitized.replace("university of", "").trim() + " university";
      }

      let abbrs = synonyms ? synonyms : [];

      if (words.includes("of")) {
        const abbrWithoutOf = words.reduce((abbr, word) => {
          return word === "of" ? abbr : abbr + word[0];
        }, "");
        abbrs.push(abbrWithoutOf);
      }

      abbrs.push(
        words.reduce((abbr, word) => {
          return abbr + word[0];
        }, "")
      );

      if (alt) {
        abbrs.push(
          alt.split(" ").reduce((abbr, word) => {
            return abbr + word[0];
          }, "")
        );
      }

      item._x_combobox_abbrevs = abbrs;

      item.setAttribute("role", "option");
      const disabled = item.hasAttribute("disabled");
      if (disabled) this.setAttribute("aria-disabled", "true");

      if (!disabled) item.setAttribute("tabindex", "-1");
    });

    this._highlightedItem = null;
    this._selectedIndex = -1;
    this._hilightedIndex = -1;
    this.expanded = false;

    this._showOptionsWhenEmptyInput =
      this.getAttribute("show-empty") === "true";
  }

  _setupInput() {
    // set input attributes
    const inputAttrs = [
      ["autocapitalize", "none"],
      ["autocomplete", "off"],
      ["spellcheck", "false"],
      ["role", "combobox"],
      ["aria-autocomplete", "list"],
    ];
    inputAttrs.forEach(([key, value]) => {
      this._input.setAttribute(key, value);
    });

    const required = this._input.hasAttribute("required");
    if (required) this._input.setAttribute("aria-required", "true");

    this._input.addEventListener("keyup", this._onInputKeyup, {
      signal: this._ac?.signal,
    });

    this._input.addEventListener("keydown", this._onInputKeydown, {
      signal: this._ac?.signal,
    });

    this._input.addEventListener("mousedown", this._onInputClick, {
      signal: this._ac?.signal,
    });
  }

  _setupOutsideClick() {
    document.body.addEventListener(
      "click",
      (event) => {
        const clickedOutside = !this.contains(event.target);
        if (clickedOutside) {
          this._hideList(true);
        }
      },
      { signal: this._ac?.signal }
    );
  }

  _setup() {
    this._setupInput();
    this._setupOutsideClick();

    this._listElement.addEventListener("keydown", this._onListKeyDown, {
      signal: this._ac?.signal,
    });
    this._listElement.addEventListener("click", this._onOptionClick, {
      signal: this._ac?.signal,
    });
  }

  get expanded() {
    return this._expanded;
  }

  set expanded(value) {
    if (typeof value !== "boolean" || value === this._expanded) return;

    this.setAttribute("aria-expanded", value.toString());
    this._expanded = value;
  }

  get _selectedOption() {
    const index = this._selectedIndex;
    return index > -1 ? this._options[index] || null : null;
  }

  connectedCallback() {
    if (!this.isConnected) return;
    this._ac = new AbortController();

    this._setup();
    this.removeAttribute("x-dehydrated");

    // trigger once
    this._showList(this._input.value, true);
  }

  disconnectedCallback() {
    if (this._ac) this._ac.abort();
    if (this.isConnected) this.setAttribute("x-dehydrated", "");

    this._ac = null;
  }

  _onInputKeyup(event) {
    switch (event.key) {
      case "Escape":
      case "ArrowUp":
      case "ArrowLeft":
      case "ArrowRight":
      case "Enter":
      case "Tab":
      case "Shift":
        break;
      case "ArrowDown":
        this._showList(event.target.value);
        this._listElement
          .querySelector(
            `[role="option"]:not([aria-disabled="true"],[data-filtered-out="true"])`
          )
          ?.focus();

        event.preventDefault();
        event.stopPropagation();
        break;

      default:
        this._showList(event.target.value);
    }
  }

  _onInputKeydown(event) {
    let flag = false;

    switch (event.key) {
      case "Escape":
        this._hideList();
        flag = true;
        break;

      case "Tab":
        this._hideList();
        break;
    }

    if (flag) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  _onInputClick(event) {
    const wasClosed = !this.expanded;
    this._showList(event.target.value);

    // Scroll selected option into view.
    // this._selectedOption?.scrollIntoView();

    if (wasClosed) {
      this._selectInputText();
    }
  }

  _isOptionElement(el) {
    if (!el) return false
    if (el && el.getAttribute('data-combobox-listitem') && el.getAttribute('role') === 'option') return true
    return false
  }

  _findOptionElement(el) {
    let found = el
    while (!this._isOptionElement(found)) {
      found = found.parentElement
      if (found.hasAttribute('data-combobox-list')) {
        return null
      }
    }
    return this._isOptionElement(found) ? found : null
  }

  _onOptionClick(event) {
    let option = this._findOptionElement(event.target)
    if (!option) return
    if (
      !option.matches(
        `[role="option"]:not([aria-disabled="true"],[data-filtered-out="true"])`
      )
    )
      return;

    this._selectOption(option);
    this._hideList();
  }

  _onListKeyDown(event) {
    let flag = false;
    this._hilightedIndex = this._selectedIndex;

    switch (event.key) {
      case "ArrowUp":
        let prevOptionElement = event.target.previousElementSibling;

        while (prevOptionElement) {
          if (
            prevOptionElement.matches(
              `[role="option"]:not([aria-disabled="true"],[data-filtered-out="true"])`
            )
          )
            break;
          prevOptionElement = prevOptionElement.previousElementSibling;
        }

        if (prevOptionElement) {
          this._hilightedIndex = this._options.findIndex(
            (opt) => opt === prevOptionElement
          );
        }
        prevOptionElement?.focus();
        flag = true;
        break;

      case "ArrowDown":
        let nextOptionElement = event.target.nextElementSibling;

        while (nextOptionElement) {
          if (
            nextOptionElement.matches(
              `[role="option"]:not([aria-disabled="true"],[data-filtered-out="true"])`
            )
          )
            break;
          nextOptionElement = nextOptionElement.nextElementSibling;
        }

        if (nextOptionElement) {
          this._hilightedIndex = this._options.findIndex(
            (opt) => opt === nextOptionElement
          );
        }
        nextOptionElement?.focus();
        flag = true;
        break;

      case "Enter":
        this._selectOption(event.target);
        this._hideList();
        flag = true;
        break;

      case "Escape":
        this._hideList();
        flag = true;
        break;

      case "Tab":
        this._hideList();
        break;

      default:
        this._hilightedIndex = this._selectedIndex;
        this._input.focus();
    }

    if (flag) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  _showList(inputValue, isInitial = false) {
    if (typeof inputValue === "string") {
      inputValue = inputValue.toLowerCase().trim();
    }

    let resultsCount = 0;
    if (!inputValue || inputValue == "") {
      resultsCount = this._showOptionsWhenEmptyInput ? this._options.length : 0;

      const filterdOut = this._showOptionsWhenEmptyInput ? "false" : "true";
      this._options.forEach((opt) => {
        opt.setAttribute("data-filtered-out", filterdOut);
      });
    } else {
      this._options.forEach((opt) => {
        const abbrs = opt._x_combobox_abbrevs;
        const value = opt._x_combobox_value_sanitized;
        const matched = opt._x_combobox_value_lowercased.includes(inputValue) ||
          abbrs.some((abbr) => abbr.startsWith(inputValue)) ||
          value.includes(inputValue);
        opt.setAttribute("data-filtered-out", matched ? "false" : "true");
        if (matched) resultsCount++;
      });
    }

    this.setAttribute("data-combobox-has-value", (!!inputValue).toString());
    this.setAttribute("data-combobox-results-count", resultsCount);

    if (!isInitial) {
      this.expanded = true;
    }
  }

  _hideList(outside = false) {
    if (!this.expanded) return;
    this._hilightedIndex = this._selectedIndex;
    if (this._selectedIndex != null && this._selectedIndex != -1) {
      const option = this._options[this._selectedIndex];
      const value =
        option._x_combobox_value ||
        option.getAttribute("data-combobox-listitem");
      this._input.value = value;
    }

    this.expanded = false;
    if (!outside) {
      this._input.focus();
    }
  }

  _selectOption(optionElement) {
    const isIndex =
      typeof optionElement === "number" &&
      Number.isInteger(optionElement) &&
      optionElement >= -1;

    if (isIndex) {
      this._selectedIndex = optionElement;
    } else {
      this._selectedIndex = this._options.findIndex(
        (opt) => opt === optionElement
      );
    }

    const option = this._selectedOption;
    if (option instanceof HTMLAnchorElement) {
      const href = option.getAttribute("href");
      if (href) {
        // save -
        // LS.setItem(UNI_FILTER_URL_KEY, href);
        // LS.removeItem(UNI_FILTER_PARAM_KEY);

        option.click();
      }
    }

    if (option) {
      const radio = option.querySelector('input[type="radio"]');
      if (radio) {
        if (this._parent_filter_bar === undefined) {
          this._parent_filter_bar =
            option.closest(".filter-bar__filters") ||
            option.closest(".filter-drawer__content");
        }

        if (this._parent_filter_bar) {
          this._parent_filter_bar
            .querySelectorAll("[data-filter-item-input]")
            .forEach((input) => {
              if (input.type === "radio" || input.type === "checkbox") {
                input.checked = false;
              }
            });
        }

        radio.checked = true;
        radio.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }
  }

  _selectInputText() {
    console.log("Selecting input text...");
    requestAnimationFrame(() => {
      if (typeof this._input.setSelectionRange === "function") {
        this._input.setSelectionRange(0, this._input.value.length);
      } else if (typeof this._input.select === "function") {
        this._input.select();
      }
    });
  }
}
window.customElements.define("x-combobox", XCombobox);

// -------------------------------------------------------------------------------------

function debounce(fn) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, 500);
  };
}

class ReadMoreableText extends HTMLElement {
  constructor() {
    super();

    this.onReadMoreClickListener = this.onReadMoreClick.bind(this);
  }

  get expanded() {
    return this.getAttribute("aria-expanded") === "true";
  }
  set expanded(bool) {
    return this.setAttribute("aria-expanded", String(!!bool));
  }

  connectedCallback() {
    this.removeAttribute("x-dehydrated");
    this.init();
  }

  disconnectedCallback() {
    this.readMores?.forEach((readMoreBtn) => {
      readMoreBtn.removeEventListener("click", this.onReadMoreClickListener);
    });
  }

  init() {
    const defaultExpanded = this.expanded;

    if (defaultExpanded) {
      this.classList.remove(ReadMoreableText.classes.clamped);
    } else {
      this.classList.add(ReadMoreableText.classes.clamped);
    }

    this._content = this.querySelector(`.${ReadMoreableText.classes.content}`);
    if (!this.showReadMoreButton()) {
      this.classList.add(ReadMoreableText.classes.unclampable);
      return;
    }

    if (defaultExpanded) {
      console.log({ defaultExpanded });
    }

    let height = this.getHeight();

    this._content.style.transition = "none";
    this.style.setProperty(
      "--element-height",
      `${defaultExpanded ? height.full : height.clamped}px`
    );
    this.style.setProperty(
      "--max-height-duration",
      `${Math.floor(height.full / 2)}ms`
    );

    this.classList.remove(ReadMoreableText.classes.clamped);

    requestAnimationFrame(() => {
      this._content.style.transition = "";
    });

    this.readMores = Array.from(this.querySelectorAll("[data-read-more]"));

    this.readMores.forEach((readMoreBtn) => {
      readMoreBtn.addEventListener("click", this.onReadMoreClickListener);
    });
  }

  onReadMoreClick(e) {
    const canExpand = e.currentTarget.getAttribute("data-read-more") === "true";
    const canRetract =
      !canExpand && e.currentTarget.getAttribute("data-read-more") === "false";

    const height = this.getHeight();

    // console.log('CLICK', { canExpand, canRetract }, e.target)
    this.style.setProperty(
      "--element-height",
      (canExpand ? height.full : height.clamped) + "px"
    );

    this.expanded = canExpand;
    if (canRetract) {
      // requestAnimationFrame(() => {
      //   this.scrollIntoView({ block: 'start' })
      // })
    }
  }

  showReadMoreButton() {
    this.classList.add(ReadMoreableText.classes.clamped);
    const sh = this._content.scrollHeight - 4;
    const oh = this._content.offsetHeight;
    this.classList.remove(ReadMoreableText.classes.clamped);

    return oh < sh;
  }

  get fullHeight() {
    return this.expanded
      ? this.clientHeight
      : this.clientHeight + this._content.scrollHeight;
  }

  getHeight() {
    if (this._height) {
      this._height.full = this.fullHeight;
      return this._height;
    }

    // Get clampped height only once
    let clampedHeight = this._content.clientHeight + 3;
    if (!this.classList.contains(ReadMoreableText.classes.clamped)) {
      this.classList.add(ReadMoreableText.classes.clamped);
      clampedHeight = this._content.clientHeight + 3;
      this.classList.remove(ReadMoreableText.classes.clamped);
    }

    this._height = { clamped: clampedHeight, full: this.fullHeight };
    return this._height;
  }
}

ReadMoreableText.classes = {
  content: "Text_Readmoreable__Content",
  clamped: "Text_Readmoreable__ContentClamped",
  unclampable: "Text_Readmoreable__Unclampable",
};

ReadMoreableText._tag = "readmoreable-text";
if (!window.customElements.get(ReadMoreableText._tag)) {
  window.customElements.define(ReadMoreableText._tag, ReadMoreableText);
}

class ReadMoreableTextInline extends HTMLElement {
  connectedCallback() {
    this._ac?.abort();
    this._ac = new AbortController();

    this.init();
  }

  disconnectedCallback() {
    this._ac?.abort();
    this._ac = null;
  }

  init() {
    const C = {
      MORE_TEXT: this.getAttribute("more-text") || "Read More",
      LESS_TEXT: this.getAttribute("less-text") || "Read Less",
    };
    C.LESS_TEXT = ` ${C.LESS_TEXT.trim()}`;

    const node = this;

    if (!node || !ReadMoreableTextInline.showReadMoreButton(node)) {
      return;
    }

    const ellipsis = node.hasAttribute("no-ellipsis") ? "" : "...";
    const readMore = document.createElement("button");
    const readMoreTextEl = document.createElement("span");

    readMore.setAttribute("type", "button");
    readMore.className = "read-more-btn";
    readMore.textContent = ellipsis;
    readMoreTextEl.textContent = C.MORE_TEXT;
    readMore.appendChild(readMoreTextEl);

    node.parentElement.style.position = "relative";
    node.parentElement.appendChild(readMore);

    let showingMore = false;
    readMore.addEventListener(
      "click",
      (e) => {
        showingMore = !showingMore;

        readMore.textContent = showingMore ? "" : ellipsis;
        readMoreTextEl.textContent = showingMore ? C.LESS_TEXT : C.MORE_TEXT;
        readMore.appendChild(readMoreTextEl);

        node.classList.toggle("inline-clamped", !showingMore);
        (showingMore ? node : node.parentElement).appendChild(readMore);
        readMore.style.position = showingMore ? "relative" : "";

        requestAnimationFrame((_) => {
          readMore.focus();
        });
      },
      { signal: this._ac?.signal }
    );
  }
}
ReadMoreableTextInline.showReadMoreButton = function showReadMoreButton(
  element
) {
  const sh = element.scrollHeight - 2;

  if (element.offsetHeight < sh || element.offsetWidth < element.scrollWidth) {
    return true;
  }

  return false;
};

ReadMoreableTextInline._tag = "readmoreable-text-inline";
if (!window.customElements.get(ReadMoreableTextInline._tag)) {
  window.customElements.define(
    ReadMoreableTextInline._tag,
    ReadMoreableTextInline
  );
}
// -------------------------------------------------------

const cartRefreshEvents = ["cart:refreshed", "quickcart:refreshed"];
cartRefreshEvents.forEach((evn) => {
  document.addEventListener(evn, function (evt) {
    // console.log("Cart Refreshed");
    // console.log(evt.detail.cartHtml);

    const affirmLoaded =
      typeof window.affirm &&
      window.affirm.ui &&
      typeof window.affirm.ui.refresh === "function";
    console.log({ affirmLoaded });
    if (affirmLoaded) {
      window.affirm.ui.refresh();
    }
  });
});

// -------------------------------------------------------
(() => {
  // listen for all `style` elements addedNodes
  const observer = new MutationObserver((mutations, observer) => {
    out: for (let i = 0, len = mutations.length; i < len; i++) {
      const mutation = mutations[i];
      if (mutation.type === "childList") {
        for (let j = 0, len2 = mutation.addedNodes.length; j < len2; j++) {
          const node = mutation.addedNodes[j];
          if (node.nodeType === 1 && node.nodeName === "STYLE") {
            let cssStr = node.innerHTML;
            if (cssStr && cssStr.startsWith("/*! tailwindcss v")) {
              const delimiter = "*,:after,:before{--tw-border-spacing-x:0";
              const parts = cssStr.split(delimiter);
              node.innerHTML = delimiter + parts[1];
            }
            // console.log('style added', node);
          }
        }
      }
    }
  });

  observer.observe(document.head, {
    childList: true,
  });
})();

// ---------------------------------------------------------------

// Ensure product form don't have 'novalidate' attr

(() => {
  // Select the form element
  const form = document.querySelector(".product-form");
  if (!form) return;
  console.log(form);

  // Create a new MutationObserver instance
  const observer = new MutationObserver((mutationsList) => {
    for (let i = 0, l = mutationsList.length; i < l; i++) {
      const mutation = mutationsList[i];
      // console.log(mutation);

      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "novalidate"
      ) {
        // console.log(mutation);
        requestAnimationFrame(() => {
          if (form.noValidate) {
            // console.log("doneeeeeeeeeeeeeeeeeeeeeee");
            form.noValidate = false;
          }
        });
      }
    }
  });

  // Start observing the form for attribute changes
  observer.observe(form, {
    attributes: true, // Observe attribute changes
    attributeFilter: ["novalidate"], // Only listen for changes to the "novalidate" attribute
  });
})();

// ---------------------------------------------------------------

function domReady(fn) {
  if (document.readyState !== 'loading') {
    fn()
  } else {
    document.addEventListener('DOMContentLoaded', fn)
  }
}

function waitForElement(selector, checkerFn, callback, root = document) {
  const element = root.querySelector(selector)
  if (element) {
    return void callback(element)
  }

  const observer = new MutationObserver((mutations, observer) => {
    let _node = null
    for (let i = 0, l = mutations.length; i < l; i++) {
      const mutation = mutations[i]

      for (let j = 0, l2 = mutation.addedNodes; j < l2.length; j++) {
        const node = mutation.addedNodes[j]
        if (node instanceof HTMLElement) {
          if (checkerFn(node)) {
            // callback(node)
            _node = node
            break
          }


          // observer.disconnect()
          // return
        }
      }
    }

    // recheck
    const node = _node || root.querySelector(selector)
    if (node) {
      callback(node)
      observer.disconnect()
      return
    }
  })

  observer.observe(root, { childList: true, subtree: true })
}

async function tick() {
  return new Promise((resolve) => {
    requestAnimationFrame(resolve)
  })
}

/*
domReady(() => {
  return
  const targetNode =  document.querySelector('.product__meta')
  if (!targetNode) return

  waitForElement('.cl-po--option[data-option="Stone Type"]', (node) => {
    return false
  }, async (node) => {

    await tick()
    const select = node.querySelector('select.cl-po--input')

    if (select &&  select instanceof HTMLSelectElement) {
      onStoneTypeSelectRender(select)
    }
  }, targetNode)
})

/**
 *
 * @param {HTMLSelectElement} select Select element which user interacts with
 *
function onStoneTypeSelectRender(select) {
  const allStoneValues = [...select.querySelectorAll('option')].map(el => el.value).filter(Boolean)

  // this is main hidden select
  const pendantBaseVariant = select.closest('.cl-po--options').querySelector('.cl-po--option[data-option="Pendant Base Variant"] select')
  if (!pendantBaseVariant) return
  pendantBaseVariant.setAttribute('tabindex', '-1')
  const allBaseValues = [...pendantBaseVariant.querySelectorAll('option')].map(el => el.value)
  const allBaseValuesSet = new Set(allBaseValues)
  const availableStyles = allBaseValues.reduce((acc, x) => {
    if (x) {
      const [shape] = x.split('_')
      acc.add(shape)
    }
    return acc
  }, new Set())



  const widget3droot = document.querySelector('.product__meta x-3d-product-options')
  if (!widget3droot) return

  const pendantStyleField = widget3droot.querySelector('[data-option="Pendant Style"]')
  if (pendantStyleField) {
    const pendantStyleSelect = pendantStyleField.querySelector('select')
    if (pendantStyleSelect) {
      const options = pendantStyleSelect.querySelectorAll('option')
      for (let i = 0, l = options.length; i < l; i++) {
        const option = options[i]
        const value = option.value
        const exist = availableStyles.has(value)
        option.disabled = !exist
      }
    }
  }


  widget3droot.addEventListener('data:change', e => {
    on3dwidgetchange(e.detail)
  })

  if (widget3droot.__event_data_change) {
    on3dwidgetchange(widget3droot.__event_data_change)
  }

  select.addEventListener('change', () => {
    on3dwidgetchange(widget3droot.__event_data_change)
  })


  async function on3dwidgetchange(detail) {
    if (!detail?.data) return
    const style = detail.data['Pendant Top Style'] || detail.data['Ring Top Style']
    let sealSize = detail.data['Seal Size']
    if (sealSize.includes('Oval')) sealSize = 'L'
    else if (sealSize.includes('10mm')) sealSize = 'N'
    else if (sealSize.includes('12mm')) sealSize = 'E'
    else sealSize = ''

    if (style && sealSize) {
      for (let i = 0, l = allStoneValues.length; i < l; i++) {
        const stone = allStoneValues[i]
        const possibleCombination = `${style}_${sealSize}_${stone}`
        const exist = allBaseValuesSet.has(possibleCombination)
        const option = select.querySelector(`option[value="${stone}"]`)
        option.disabled = !exist
        if (!exist) {
          option.selected = false
        }
      }

      let stone = select.value
      const option = stone ? select.querySelector(`option[value="${stone}"]`) : null
      if (option) {
        requestAnimationFrame(() => {
          option.selected = true
        })
      }

      if (!stone) {
        for (let i = 0, l = allStoneValues.length; i < l; i++) {
          const stone = allStoneValues[i]
          const possibleCombination = `${style}_${sealSize}_${stone}`
          const exist = allBaseValuesSet.has(possibleCombination)
          if (exist) {
            select.value = stone
            break
          }
        }
      }

    }

    const stone = select.value
    let value = stone && style && sealSize ? `${style}_${sealSize}_${stone}` : ''

    pendantBaseVariant.value = value
    pendantBaseVariant.dispatchEvent(new Event('change', { bubbles: true }))
  }

}
*/

domReady(() => {
  const targetNode =  document.querySelector('.product__meta')
  if (!targetNode) return

  waitForElement('.cl-po--option[data-option="_Pendant Base Variant"]', (node) => {
    return false
  }, async (node) => {

    await tick()
    const pendantBaseVariantSelect = node.querySelector('select.cl-po--input')

    if (pendantBaseVariantSelect &&  pendantBaseVariantSelect instanceof HTMLSelectElement) {
      const parent = node.closest('.cl-po--wrapper')
      if (parent) parent.remove()

      // onPendantBaseVariantSelectRender(pendantBaseVariantSelect)
    }
  }, targetNode)
})

function onPendantBaseVariantSelectRender(pendantBaseVariantSelect) {
  const widget3d = document.querySelector('.product__meta x-3d-product-options')
  if (!widget3d) return

  const twoToneCheckbox = pendantBaseVariantSelect.closest('.cl-po--options').querySelector('[data-option="_2-Tone"] input.cl-po--input[type="checkbox"]')

  widget3d.addEventListener('data:change', e => {
    on3dwidgetchange(e.detail)
  })
  if (widget3d.__event_data_change) {
    on3dwidgetchange(widget3d.__event_data_change)
  }

  function on3dwidgetchange(detail) {
    const json = detail?.data?._json
    if (!json) return

    const style = json.top_style.value
    const sealSize = json.seal.value // N, E, L

    const stone = json.stone
    let value = stone && style && sealSize ? `${style}_${sealSize}_${stone}` : ''

    pendantBaseVariantSelect.value = value

    const twoTone = json.two_tone

    pendantBaseVariantSelect.dispatchEvent(new Event('change', { bubbles: true }))
    requestAnimationFrame(() => {
      twoToneCheckbox.checked = twoTone === true
      twoToneCheckbox.dispatchEvent(new Event('change', { bubbles: true }))
    })
  }
}

function threedWidgetAddToCart(widget) {
  const parent = widget.closest('.product__meta')
  if (!parent) return

  const mainAddToCart = parent.querySelector('button[type="submit"][data-add-to-cart]')
  if (!mainAddToCart) return
  let mainForm = mainAddToCart.closest('form') || mainAddToCart.form
  if (!mainForm) return 
  
  // const portalContainer = widget.__portalsElement
  const widgetId = widget.id || ''
  const portalContainersSelector = widgetId ? '[data-portals-container-root-id="' + widgetId + '"]' : null
  const allPortalsContainers = portalContainersSelector ? [...document.querySelectorAll(portalContainersSelector)] : null
  
  let addToCartElements = [
    ...widget.querySelectorAll('button[data-btn-atc]'),
    ...(portalContainersSelector ? document.querySelectorAll(portalContainersSelector + ' button[data-btn-atc]') : []),
  ]

  syncElementAttrs(mainAddToCart, addToCartElements, ['data-loading', 'disabled'])
  
  const obs2 = new MutationObserver(() => {
    const loading = mainAddToCart.getAttribute('data-loading') === 'true'
    if (loading) {
      widget.setAttribute('aria-disabled', 'true')
      allPortalsContainers?.forEach(portalContainer => {
        portalContainer?.setAttribute('aria-disabled', 'true')
      })
    } else {
      widget.removeAttribute('aria-disabled')
      allPortalsContainers?.forEach(portalContainer => {
        portalContainer?.removeAttribute('aria-disabled')
      })
    }
  }).observe(mainAddToCart, {
    attributes: true,
    attributeFilter: ['data-loading']
  })
  
  // const input1 = document.createElement('input')
  // input1.type = 'hidden'
  // input1.name = 'properties[_cl_options_id]'
  // input1.value = '3d-widget-options'
  // const input2  = document.createElement('input')
  // input2.type = 'hidden'
  // input2.name = 'properties[_cl_options]'
  // input2.value = '3d-widget-options'
  
  // mainForm.appendChild(input1)
  // mainForm.appendChild(input2)

  addToCartElements.forEach(fakeAtc => {
    fakeAtc.addEventListener('click', e => {
      const liveProductOptionsDiv = mainForm.querySelector('.cl-po--wrapper')
      if (liveProductOptionsDiv) liveProductOptionsDiv.remove()
      mainAddToCart.click()
    }, true)
  })
  
  document.addEventListener('cart:item-added', e => {
    window.scrollTo({top: 0, behavior: 'smooth'})
  })
}


function syncElementAttrs(source, targets, attrs) {
  if (targets instanceof HTMLElement) targets = [targets]

  const apply = () =>
    targets.forEach(t => {
      attrs.forEach(a => {
        if (source.hasAttribute(a)) {
          const value = source.getAttribute(a)
          t.setAttribute(a, value)
        } else {
          t.removeAttribute(a)
        }
      })
    })

  apply()

  const obs = new MutationObserver(apply).observe(source, {
    attributes: true,
    attributeFilter: attrs
  })
  
  return () => obs.disconnect()
}

class X3dProductOptionsCustomWrapper extends XThemeBaseElement {
  mount() {
    const widget = this.querySelector('x-3d-product-options')
    if (!widget) return
    
    this.addEventListener('widget:loaded', e => {
      threedWidgetAddToCart(widget)
    })
  }
}
if (!window.customElements.get('x-3d-product-options-custom-wrapper')) {
  window.customElements.define('x-3d-product-options-custom-wrapper', X3dProductOptionsCustomWrapper)
}

// ---------------------------------------------------------------

// rsvp form after-submit
(() => {
  if (location.host.startsWith("localhost")) return;

  const CURRENT_URL = new URL(window.location.href);
  const SEARCH_PARAMS = CURRENT_URL.searchParams;
  const KDEV =
    SEARCH_PARAMS.get("k_dev") || location.host.startsWith("localhost");

  document.addEventListener("x-pluggable-form::submit-complete", (e) => {
    const { form } = e.detail;
    if (form.hasAttribute("data-events-rsvp-form")) {
      afterRsvpFormSubmit(e.detail);
      return;
    }
  });

  /**
   * @typedef {{
   *  element: XPluggableForm,
   *  form: HTMLFormElement,
   *  formData: FormData
   *  formJson: Record<string, any>
   *  integrationKeys: string[]
   *  integrationSettings: Record<string, Record<string, string>>
   * }} XPluggableFormSubmitEventDetails
   */

  /**
   *
   * @param {XPluggableFormSubmitEventDetails} detail
   */
  async function afterRsvpFormSubmit(detail) {
    const { element: xPluggableForm } = detail;

    const form = xPluggableForm.form;
    if (!form) return;

    let eventJsonOutput = null;
    try {
      eventJsonOutput = JSON.parse(
        form.querySelector("script[data-event-json-output]").textContent
      );
    } catch (e) {}
    const json = detail.formJson;
    if (!json.email) return;

    const promises = [];

    // update customer
    if (eventJsonOutput?.Event) {
      promises.push(upsertCustomer(detail, eventJsonOutput.Event));
    }

    const integrationSettings =
      xPluggableForm.allIntegrationSettings["klaviyo"];

    // integration disabled
    if (!integrationSettings || !integrationSettings.a) {
      return Promise.allSettled(promises);
    }

    if (KDEV) {
      integrationSettings.a = "QQyd2Z";
      integrationSettings.g = "RzPhNs";
    }

    let klaviyoModuleUrl = detail.element.getAttribute('klaviyo-asset-url')
    if (klaviyoModuleUrl && klaviyoModuleUrl.startsWith('//')) {
      klaviyoModuleUrl = 'https:' + klaviyoModuleUrl
    }

    return import(klaviyoModuleUrl || `./x-pluggable-form-plugin-klaviyo.mod.js?v=${randomInt(112312, 213423592)}`).then(async (mod) => {
      const klaviyoApi = mod.klaviyoApi;
      const customerProps = {
        "RSVP for Event": true,
        "Last RSVP Event": eventJsonOutput
          ? eventJsonOutput.Event
          : "<Unknown Event>",
        School: json.school_other || json.school,
      };

      promises.push(
        klaviyoApi.event({
          ...integrationSettings,
          event_name: `RSVP for Event`,
          attributes: {
            properties: eventJsonOutput || {},
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: json.email,
                  properties: customerProps,
                },
              },
            },
          },
        })
      );

      return Promise.allSettled(promises);
    });
  }

  /**
   *
   * @param {XPluggableFormSubmitEventDetails} detail
   * @param {string} eventName
   * @returns
   */
  async function upsertCustomer(detail, eventName) {
    const noCreate = SEARCH_PARAMS.get("_no-customer-create") || "0";
    if (noCreate === "1" || noCreate === "true") return;

    const json = detail.formJson;

    let name = json.name || "";
    let email = json.email || "";
    let phone = json.phone || "";
    let school = json.school_other || json.school || "";

    if (!email) return;

    const tags = [school];
    if (eventName) tags.push(eventName);
    return fetch(
      `https://cedarsphere-workers.ziad-388.workers.dev/api/create-customer-rsvp?shop=${Shopify.shop}`,
      {
        method: "POST",
        headers: { accept: "application/json" },
        body: JSON.stringify({
          fullname: name,
          email,
          phone,
          accepts_marketing: true,
          tags: tags,
        }),
      }
    )
      .then((r) => r.json())
      .then((data) => {
        console.log("Created/Updated Customer", data);
        return data;
      })
      .catch((e) => {
        console.log("Error creating customer");
        console.error(e);
        return null;
      });
  }

  function randomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
  }
})();




// ----------------------------------------------------------------------------------------

const onYouTubePromise = new Promise((resolve) => {
  window.onYouTubeIframeAPIReady = () => resolve();
});
class MotionCustom {
  static inView(element, callback) {
    let disconnectCallback = null;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            disconnectCallback = callback.call(element);
          } else if (disconnectCallback) {
            disconnectCallback.call(element);
            disconnectCallback = null;
          }
        });
      },
      { threshold: 0 }
    );

    observer.observe(element);

    return observer; // Return the observer so it can be unobserved if needed
  }
}

class DeferredMedia extends HTMLElement {
  constructor() {
    super();

    if (this.posterElement) {
      this.posterElement.addEventListener('click', this.onPosterClick.bind(this));
    }

    if (this.autoplay) {
      MotionCustom.inView(this, () => {
        if (!this.paused) {
          this.play();
        }
        return () => {
          this.pause();
        };
      });
    }
  }

  get posterElement() {
    return this.querySelector('[id^="DeferredPoster-"]');
  }

  get controlledElement() {
    return this.hasAttribute('aria-controls') ? document.getElementById(this.getAttribute('aria-controls')) : null;
  }

  get autoplay() {
    return this.hasAttribute('autoplay');
  }

  get playing() {
    return this.hasAttribute('playing');
  }

  get player() {
    return this.playerProxy = this.playerProxy || new Proxy(this.playerTarget(), {
      get: (target, prop) => {
        return async () => {
          target = await target;
          this.playerHandler(target, prop);
        };
      }
    });
  }

  static get observedAttributes() {
    return ['playing'];
  }

  onPosterClick(event) {
    event.preventDefault();
    event.stopPropagation();

    if (this.playing) {
      this.paused = true;
      this.pause();
    }
    else {
      this.paused = false;
      this.play();
    }
  }

  play() {
    if (!this.playing) {
      this.player.play();
    }
  }

  pause() {
    if (this.playing) {
      this.player.pause();
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'playing') {
      if (oldValue === null && newValue === '') {
        return this.dispatchEvent(new CustomEvent('video:play', { bubbles: true }));
      }

      if (newValue === null) {
        return this.dispatchEvent(new CustomEvent('video:pause', { bubbles: true }));
      }
    }
  }
}

class VideoMedia extends DeferredMedia {
  constructor() {
    super()
  }

  playerTarget() {
    if (this.hasAttribute('host')) {
      this.setAttribute('loaded', '')
      this.closest('.media')?.classList.remove('loading')

      return new Promise(async (resolve) => {
        const templateElement = this.querySelector('template')
        if (templateElement) {
          templateElement.replaceWith(templateElement.content.firstElementChild.cloneNode(true))
        }
        const muteVideo =
          this.hasAttribute('autoplay') ||
          window.matchMedia('screen and (max-width: 1023px)').matches
        const script = document.createElement('script')
        script.type = 'text/javascript'
        if (this.getAttribute('host') === 'youtube') {
          if (!window.YT || !window.YT.Player) {
            script.src = 'https://www.youtube.com/iframe_api'
            document.head.appendChild(script)
            await new Promise((resolve2) => {
              script.onload = resolve2
            })
          }
          await onYouTubePromise
          const player = new YT.Player(this.querySelector('iframe'), {
            events: {
              onReady: () => {
                if (muteVideo) {
                  player.mute()
                }
                resolve(player)
              },
              onStateChange: (event) => {
                if (event.data === YT.PlayerState.PLAYING) {
                  this.setAttribute('playing', '')
                } else if (
                  event.data === YT.PlayerState.ENDED ||
                  event.data === YT.PlayerState.PAUSED
                ) {
                  this.removeAttribute('playing')
                }
              },
            },
          })
        }

        if (this.getAttribute('host') === 'vimeo') {
          if (!window.Vimeo || !window.Vimeo.Player) {
            script.src = 'https://player.vimeo.com/api/player.js'
            document.head.appendChild(script)
            await new Promise((resolve2) => {
              script.onload = resolve2
            })
          }
          const player = new Vimeo.Player(this.querySelector('iframe'))
          if (muteVideo) {
            player.setMuted(true)
          }
          player.on('play', () => {
            this.setAttribute('playing', '')
          })
          player.on('pause', () => this.removeAttribute('playing'))
          player.on('ended', () => this.removeAttribute('playing'))
          resolve(player)
        }
      })
    } else {
      let videoEl = this.querySelector('video')
      let templateEl = this.querySelector('template')

      if (!videoEl && !templateEl) {
        this.setAttribute('suspended', '')
        this.setAttribute('data-error', 'No video element nor template element found')
        return
      }

      if (!videoEl && templateEl) {
        this.appendChild(templateEl.content.firstElementChild.cloneNode(true))
      }

      this.setAttribute('loaded', '')
      this.closest('.media')?.classList.remove('loading')

      const player = this.querySelector('video')
      player.addEventListener('play', () => {
        this.setAttribute('playing', '')
        this.removeAttribute('suspended')
      })
      player.addEventListener('pause', () => {
        if (!player.seeking && player.paused) {
          this.removeAttribute('playing')
        }
      })
      return player
    }
  }

  playerHandler(target, prop) {
    if (this.getAttribute('host') === 'youtube') {
      prop === 'play' ? target.playVideo() : target.pauseVideo()
    } else {
      if (prop === 'play' && !this.hasAttribute('host')) {
        target.play().catch((error) => {
          if (error.name === 'NotAllowedError') {
            this.setAttribute('suspended', '')
            target.controls = true
            const replacementImageSrc = target.previousElementSibling?.currentSrc
            if (replacementImageSrc) {
              target.poster = replacementImageSrc
            }
          }
        })
      } else {
        target[prop]()
      }
    }
  }
}
customElements.define('video-media', VideoMedia);

class X3dViewerThinkspace extends XThemeBaseElement {
  constructor() {
    super()
  }

  _hideInstructionImg() {
    const el = this._instructionImg
    el.style.visibility = 'hidden'
    el.style.display = 'none'
  }

  mount() {
    const iframe = this.querySelector('iframe')
    this._instructionImg = this.querySelector('.iframe-3d-instruction-msg')
    if (!iframe || !this._instructionImg) return

    const isMobile = window.matchMedia('screen and (max-width: 958px)').matches

    iframe.addEventListener('load', () => {
      this._instructionImg.style.visibility = ''

      if (isMobile) {
        this.timeout = setTimeout(() => {
          this._hideInstructionImg()
          clearInterval(this.iframewatcher)
          this.iframewatcher = null
          this.timeout = null
        }, 10000)
      }

    }, { signal: this._ac?.signal })

    this._instructionImg.addEventListener('click', () => {
      this._hideInstructionImg()
    }, { once: true, signal: this._ac?.signal })

    const HTML_IFRAME_ELEMENT = HTMLIFrameElement
    this.iframewatcher = setInterval(() => {
      let activeE = document.activeElement
      if (activeE && activeE instanceof HTML_IFRAME_ELEMENT) {
        clearInterval(this.iframewatcher)
        this.iframewatcher = null

        this._hideInstructionImg()
      }
    }, 300)
  }

  unmount() {
    const interval = this.iframewatcher
    if (interval) {
      clearInterval(interval)
      this.iframewatcher = null
    }

    const timeout = this.timeout
    if (timeout) {
      clearTimeout(timeout)
      this.timeout = null
    }
  }
}
customElements.define('x-3d-viewer-thinkspace', X3dViewerThinkspace)

class XStickySentinel extends XThemeBaseElement {
  mount() {
    const elId = this.getAttribute('data-target-id')
    if (!elId) return
    const stickyElement = document.getElementById(elId)
    if (!stickyElement) return

    const atcButton = this.hasAttribute('data-atc-btn')
      ? this.closest('.product__primary')?.querySelector?.('.product-form__cart-submit')
      : null
    this._atcButton = atcButton

    // Add a class for initial styling if needed, e.g., when not stuck
    stickyElement.classList.add('not-stuck')
    let lastScrollY = window.scrollY
    let isStuck = false; // Initial state assumption


    if (atcButton) {
      // Observer for the ATC button
      this._atc_obs = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const currentScrollY = window.scrollY
            const scrollingDown = currentScrollY > lastScrollY
            lastScrollY = currentScrollY

            if (scrollingDown) {
              if (entry.isIntersecting) {
                  // ATC button has entered the bottom 50% of the viewport while scrolling down
                  // This is our trigger to unstick
                  if (isStuck) {
                      stickyElement.classList.remove('is-stuck');
                      stickyElement.classList.add('not-stuck');
                      isStuck = false;
                      console.log('ATC crossed 50% viewport (down) -> UNSTICK');
                  }
              }
          } else { // Scrolling up
              if (!entry.isIntersecting) {
                  // ATC button has left the bottom 50% of the viewport while scrolling up
                  // This means it's above the 50% mark again, time to re-stick
                  if (!isStuck) {
                      stickyElement.classList.remove('not-stuck');
                      stickyElement.classList.add('is-stuck');
                      isStuck = true;
                      console.log('ATC left 50% viewport (up) -> RESTICK');
                  }
              }
          }
          })
        },
        {
          root: null, // Observe intersection with the viewport
        rootMargin: '0px 0px -50% 0px', // Shrink the root's bottom by 50%.
                                       // Intersection now happens when the element crosses the middle.
        threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9] // Trigger as soon as the element crosses the modified root boundary
        }
      )

      this._atc_obs.observe(atcButton)
    }


    const observerOptions = {
      // Observe the intersection with the viewport
      root: null,
      // A small negative margin can help trigger it slightly before it's visually stuck
      rootMargin: '0px 0px -1px 0px', // Observe when 1px of sentinel is below viewport top
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // The sentinel is visible in the viewport.
          // This often means the sticky element is NOT stuck (it's scrolling normally).
          // stickyElement.classList.remove('is-stuck')
          // stickyElement.classList.add('not-stuck')
        } else {
          // The sentinel is no longer visible (it has scrolled past the threshold).
          // This means the sticky element IS stuck.
          // stickyElement.classList.add('is-stuck')
          // stickyElement.classList.remove('not-stuck')
        }
      })
    }, observerOptions)

    observer.observe(this)

    this._obs = observer
  }

  unmount() {
    if (this._obs) {
      this._obs.disconnect()
      this._obs = null
    }

    if (this._atc_obs) {
      this._atc_obs.disconnect()
      this._atc_obs = null
    }
  }
}
if (!window.customElements.get('x-sticky-sentinel')) {
  window.customElements.define('x-sticky-sentinel', XStickySentinel)
}
